import React, {useEffect, useRef, useState} from 'react';
import {useLocation, useParams} from 'react-router-dom';
import {useDispatch} from 'react-redux';
// import Select2 from "react-select2-wrapper";
import axios from 'axios';
import Cookies from "js-cookie";

import actions from 'actions/index.js';
import * as constants from 'constants/index.js';
import {validateForm} from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import TableCustom from 'views/pages/components/TableCustom';
import {InputArraySelect, InputKeySelect, KeySelect, SelectWithoutInput} from 'views/pages/components/InputSelect';

import {Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Modal, Row,} from "reactstrap";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import InputCustom from "@pages/components/InputCustom";
import CustomLabel from "@pages/components/CustomLabel";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import notify from "@utils/notify";
import CreateTaskModal from "@pages/customers/customer/task/components/CreateTaskModal";

export default function Task() {
  const { customerId } = useParams();
  const location = useLocation();
  const parentPath = {
    pathname: '/admin/customer/' + customerId + '/edit',
    state: {
      filter: location.state && location.state.filter? location.state.filter: ''
    }
  };
  const dispatch = useDispatch();

  const [token, setToken] = useState('');
  const [tasks, setTasks] = useState([]);
  const [dealerMembers, setDealerMembers] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const [loading, setLoading] = useState(true);
  const [isNotValid, setIsNotValid] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editing, setEditing] = useState(false);
  const [confirmShow, setConfirmShow] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState('');

  const [task, setTask] = useState('');
  const [errors, setErrors] = useState('');


  const updateTask = (updatedTask) => {
    axios({
      method: 'PUT',
      url: constants.API_URL + '/customer/tasks/' + task.uuid,
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        ...updatedTask,
        due_date: setDate(updatedTask.due_date)
      },
    })
        .then(response => {
          setErrors('');
          if (response.status === 200) {
            window.location.reload()
          }
        })
        .catch(error => {
          setErrors('');
          console.error('error :: ', error);
          if (error.response && error.response.status === 422) {
            let errors = error.response.data.errors;
            setErrors(errors);
          }
          notify.warning(error.response.statusText);
        })
  }
   const getCustomerTaskData = async (id)=>{
     setEditing(true)
     const response = await axios({
       method: 'GET',
       url: `${constants.API_URL}/customer/${customerId}/tasks/${id}/edit`,
       headers: {
         Authorization: `Bearer ${token}`,
       },
     })
     const data = response.data
     let item = data.data.item;
     item.task_assignee = item.task_assignee.map(item=>item.id)
     const date = setDate(item.due_date)
     setTask({
      ...item,
      due_date: item?.due_date? date  : '',
     });
   }
  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/customer/${customerId}/tasks`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        const data = response.data
        setTasks(data.data.tasks)

        let members = data.data.dealerMembers
        members.forEach(member => {
          member.text = member.name
          delete member.name
        });
        setDealerMembers(members)
        setStatuses(data.data.statuses)
        setLoading(false)
      } catch (error) {
        setLoading(false)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning(error.response.data.message ? error.response.data.message : error.response.statusText)
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const deleteTask = () => {
    axios({
      method: 'DELETE',
      url: constants.API_URL + '/customer/' + customerId + '/tasks/' + selectedTaskId,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(response => {
        setConfirmShow(false);
        if (response.status === 200) {
          let data = response.data;
          console.log('deleted data :: ', data);
          setTasks(data.data);
          notify.success(response.data.message);
        }
      })
      .catch(error => {
        console.error('error :: ', error);
        setConfirmShow(false);
        notify.warning(error.response.statusText);
      })
  }

  const editTask = (row) => {
    getCustomerTaskData(row.uuid)
    setAddModal(true)
    // history.push({
    //   pathname: '/admin/customer/' + customerId + '/tasks/' + row.uuid + '/edit',
    //   state: {
    //     filter: location.state && location.state.filter? location.state.filter: ''
    //   }
    // })
  }

  const addTask = (tempTask) => {
    axios({
      method: 'POST',
      url: constants.API_URL + '/customer/' + customerId + '/tasks',
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: { ...tempTask, task_category: 'customer-manually' },
    })
      .then(response => {
        setAddModal(false);
        setErrors('');
        if (response.status === 200) {
          window.location.reload()
          notify.success(response.data.message);
        }
      })
      .catch(error => {
        setErrors('');
        console.error('error :: ', error);
        if (error.response && error.response.status === 422) {
          let errors = error.response.data.errors;
          setErrors(errors);
          return;
        }
        setAddModal(false);
        notify.warning(error.response.statusText);
      })
  }

  const formatDate = (d) => {
    if (d) {
      let date = new Date(d);
      let option = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: 'numeric', minute: 'numeric', second: '2-digit',
        hour12: false,
      }
      let formatedDate = new Intl.DateTimeFormat('en-GB', option).format(date);
  
      return formatedDate;
    }
  }
  const setDate = (d) => {
    if (d) {
      let date = new Date(d);
      let ye = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(date);
      let mo = new Intl.DateTimeFormat('en', {month: '2-digit'}).format(date);
      let da = new Intl.DateTimeFormat('en', {day: '2-digit'}).format(date);

      return `${ye}-${mo}-${da}`;
    }
  }
  useEffect(()=>{
    const required = ['title',
      'comments', 'status']

    setIsNotValid(!validateForm(required,task));
  },[task])
  return (
    <>
      <CardsHeader name="Customers" parentName="Customer Management" currentName="Task List" parentPath={parentPath} />

      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Tasks</h1>
                  </Col>
                  <Col xs={4} className="text-right">
                    <ButtonContainer onClick={() => {
                      setTask('')
                      setEditing(false)
                      setAddModal(true)
                    }}>
                      <i className="fa fa-plus" aria-hidden="true"></i>
                      Add Task
                    </ButtonContainer>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom 
                  loading={loading}
                  items={tasks}
                  keyField={`title`}
                  searchField={true}
                  columns={[
                    {
                      dataField: "title",
                      text: "Title",
                      sort: true
                    },
                    {
                      dataField: "status",
                      text: "Status",
                      sort: true
                    },
                    {
                      dataField: "created_at",
                      text: "Created at",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return formatDate(row.created_at)
                      }
                    },
                    {
                      dataField: "updated_at",
                      text: "Updated at",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return formatDate(row.updated_at)
                      }
                    },
                    {
                      dataField: "",
                      text: "Action",
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            <IcoMoon
                                className={'cursor-pointer'}
                                iconSet={IconSet}
                                icon={'edit'}
                                size={24}
                                onClick={() => editTask(row)}
                            />
                            <IcoMoon
                                className={'cursor-pointer'}
                                iconSet={IconSet}
                                icon={'delete_outline'}
                                size={24}
                                onClick={() => {
                                  setConfirmShow(true);
                                  setSelectedTaskId(row.uuid);
                                }}
                            />
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <CreateTaskModal
            addModal={addModal}
            setAddModal={setAddModal}
            initialTask={task}
            dealerMembers={dealerMembers}
            addTask={addTask}
            editing={editing}
            setEditing={setEditing}
            updateTask={updateTask}
            errors={errors}
            statuses={statuses}
            isNotValid={isNotValid}
        />
        <Modal
          isOpen={confirmShow}
          toggle={() => setConfirmShow(false)}
          className="modal-dialog-centered modal-secondary"
        >
          <div className="modal-body justify-content-center">
            {`Are you sure you want to delete this task?`}
          </div>
          <div className="modal-footer justify-content-end">
            <ButtonContainer
              onClick={() => deleteTask()}
            >
              {`Delete`}
            </ButtonContainer>
            <ButtonContainer
              reverse
              onClick={() => setConfirmShow(false)}
            >
              Cancel
            </ButtonContainer>
          </div>
        </Modal>
      </Container>
    </>
  )
}